import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Gift, Copy } from "lucide-react";
import { API, errText, useAuth } from "@/lib/auth";

// Remembers ?ref=CODE from an invite link and claims it once the visitor has an account.
export const useReferralClaim = () => {
  const { profile, refresh } = useAuth();
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) localStorage.setItem("ref_code", ref);
  }, []);
  useEffect(() => {
    const code = localStorage.getItem("ref_code");
    if (!profile || !code) return;
    localStorage.removeItem("ref_code");
    axios.post(`${API}/me/referral/claim`, { code }).then((r) => { toast.success(r.data.message); refresh?.(); }).catch((e) => toast.error(errText(e)));
  }, [profile]); // eslint-disable-line react-hooks/exhaustive-deps
};

export const ReferralCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/me/referral`).then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const link = `${window.location.origin}/account?ref=${d.code}`;
  const copy = async (e) => {
    try { await navigator.clipboard.writeText(link); toast.success("Invite link copied"); }
    catch { e.currentTarget.parentElement.querySelector("input").select(); toast("Press and hold the link to copy it"); }
  };
  return (
    <section className="glass p-5 space-y-3" data-testid="referral-card">
      <h2 className="font-head font-semibold flex items-center gap-2"><Gift className="w-4 h-4 text-[var(--violet)]" />Invite friends, get Pro free</h2>
      <p className="text-xs text-slate-400">{d.reward}</p>
      <div className="flex gap-2">
        <input readOnly value={link} className="flex-1 min-w-0 h-11 rounded-xl bg-[var(--bg)] border border-[var(--line)] px-3 text-xs font-num" data-testid="referral-link" />
        <button onClick={copy} className="btn-primary shrink-0" data-testid="referral-copy-btn"><Copy className="w-4 h-4" />Copy</button>
      </div>
      <div className="text-xs text-slate-500 font-num" data-testid="referral-stats">{d.referred} friends joined{d.bonus_pro_until && d.bonus_pro_until * 1000 > Date.now() ? ` · free Pro until ${new Date(d.bonus_pro_until * 1000).toLocaleDateString()}` : ""}</div>
    </section>
  );
};
